module.exports = __webpack_public_path__ + "img/Metal Porosity.ae148989.png";